var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-list-content"},_vm._l((_vm.stepList),function(step,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(index === _vm.activeIndex),expression:"index === activeIndex"}],key:index,staticClass:"step"},[_vm._t(step.contentSlot,null,{"step":step})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }